export default __webpack_public_path__ + "be3223cfd14deb03c3bfd80aa5b743d6.png";